import { useCallback } from "react";

import useTenantAwareNavigation from "./useTenantAwareNavigation";

import { ROUTE } from "@/constants/route";

export const useNavigateWorkflow = (workflowId?: string): (() => void) => {
  const navigate = useTenantAwareNavigation();

  return useCallback(() => {
    navigate(`${ROUTE.WORKFLOW.to}/${workflowId}`);
  }, [navigate, workflowId]);
};
